import {Base} from "@/api/Base"

export class LeaveReject extends Base {
    path = "leave/reject"
}